

import SubfamilyModel from '@/models/Warehouse/WhSubfamily'

const createSubfamily = async function (familyId , data){
    try{
        
        let subfamily = new SubfamilyModel({})
        subfamily.subfamily = data.subfamily
        subfamily.wh_family_id = familyId
        let response = await subfamily.save()
        return response 
    }
    catch(error){
        return error.response.data
    }
}

const fetchSubfamily = async function (id){
    try{
        let subfamily = await SubfamilyModel.find(id)
        return subfamily
    }
    catch(error){
        return error.response.data
    }
}

const updateSubfamily = async function (subFamiliaId, data){
    try{
        let subfamily = await fetchSubfamily(subFamiliaId)
        subfamily.subfamily = data
        let response =await subfamily.save()
        return response
    }
    catch(error){
        return error.response.data
    }
}

const fetchAllSubfamilyByFamilyId = async function(familyID){
    try{
        let subfamily = await SubfamilyModel.where('wh_family_id',familyID).get()
        return subfamily.data
    }
    catch(error){
        return error.response.data
    }
}

const fetchAllSubfamily = async function(){
    try{
        let subfamily = await SubfamilyModel.get()
        return subfamily.data
    }
    catch(error){
        return error.response.data
    }
}

const deleteSubfamily = async function(id){
    try{
        let subfamily = await SubfamilyModel.find(id)
        let response = await subfamily.delete()
        return response
    }
    catch(error){
        return error.response.data
    }
}

/**
 *
 */
const fetchByFamily = async ( wh_family_id ) => {
    //
    try {
        //
        const response = await SubfamilyModel.where( 'wh_family_id', wh_family_id ).get()
        //
        return response.data
    } catch (error) {
        //
        return error.response.data
    }
}


export default {
    createSubfamily,
    fetchSubfamily,
    updateSubfamily,
    fetchAllSubfamilyByFamilyId,
    fetchAllSubfamily,
    fetchAll: fetchAllSubfamily,
    deleteSubfamily,
    fetchByFamily,
}